<div class="header p-d-flex shadow-2" [ngClass]="{'align-items-start': isMobile}">
    @if(!isMobile){
    <div class="p-mr-auto header-left justify-content-between">
        @if(!isResponsive){
            <p-button (onClick)="sideNavToggle()" icon="pi pi-bars" [text]="true"></p-button>
        }
        @if(isResponsive){
            <div class="flex align-items-center w-full gap-1">
                <p-button (onClick)="sideNavToggle()" icon="pi pi-bars" [text]="true"></p-button>
                <div class="flex align-items-center min-w-0">
                    <p-image (click)="goToDashboard()" class="cursor-pointer" [src]="appLogo" alt="Image"
                        [class.pt-2]="isPwcEnabled"
                        [class.pwc-logo]="isPwcEnabled"
                        [width]="isPwcEnabled ? '90' : '127'" 
                        [height]="isPwcEnabled ? '50' : '62'" />
                        @if(isPwcEnabled){
                            <h5 class="m-0 ml-2 product-name pwc-product-name">Managed Review Deployment</h5>
                        }
                </div>
                <div class="flex align-items-center gap-1 ml-auto flex-shrink-0">
                    @if(isClientPortalUser()){
                        <ng-container *ngTemplateOutlet="clientAccountMenu"></ng-container>
                    }
                    @if(userRole === 'REVIEWER' && from === 'dashboard'){
                    <span (click)="getUnreadNotificationCount() > 0 && menu.toggle($event);toggleNotification(menu);"
                        pBadge value="{{getUnreadNotificationCount()}}"
                        class="{{helperService.getEnvironmentName()}}-icon icon-alert-outlined text-2xl text-primary cursor-pointer"></span>
                    <p-menu #menu [model]="notifications" [popup]="true" styleClass="w-full md:w-25rem overflow-auto h-30rem">
                        <ng-template pTemplate="submenuheader" let-item>
                            <span class="font-medium text-sm ">Notifications</span>
                        </ng-template>
                        <ng-template pTemplate="item" let-item>
                            <div class="px-3 pt-3" (click)="markRead($event, item)">
                                <div class="flex flex-column gap-2 border-bottom-1 surface-border pb-3">
                                    <div class="flex justify-content-between">
        
                                        <div class="flex flex-column gap-2 w-8 as-end">
                                            <div class="flex flex-column text-black-alpha-80">
                                                <span [ngClass]="item.readMore ? 'white-space-nowrap' : ''"
                                                    class="text-sm font-medium w-12 overflow-hidden text-overflow-ellipsis">{{
                                                    item.subject }}</span>
                                                <span [ngClass]="item.readMore ? 'white-space-nowrap' : ''"
                                                    class="text-sm w-12 overflow-hidden text-overflow-ellipsis">{{ item.message
                                                    }}</span>
                                                <span class="text-xs font-medium text-primary as-end"
                                                    (click)="readMore($event, item)">
                                                    {{item.readMore ? 'Read More' : 'Read Less'}}</span>
                                            </div>
                                        </div>
        
                                        <div class="text-xs text-black-alpha-60 flex gap-1">
                                            <p-divider layout="vertical" styleClass="py-2" />
                                            <div class="flex flex-column">
                                                <span>{{item.createdAt | date:"MMMM dd YYYY" }}</span>
                                                <span class="font-bold">{{item.createdAt | date:"hh:mm a" }}</span>
                                            </div>
                                        </div>
        
                                    </div>
        
                                </div>
                            </div>
                        </ng-template>
                    </p-menu>
                } 
                    @if(!isClientPortalUser()){
                    <span (click)="logout()" class="{{helperService.getEnvironmentName()}}-icon icon-logout-outlined cursor-pointer primary text-xl"></span>
                    }
                </div>
            </div>
        }
        @if(!isResponsive){
            <div class="flex align-items-center justify-content-center">
                <p-image (click)="goToDashboard()" class="cursor-pointer" [src]="appLogo" alt="Image"
                    [class.pt-2]="isPwcEnabled"
                    [class.pwc-logo]="isPwcEnabled"
                    [width]="isPwcEnabled ? '90' : '127'" 
                    [height]="isPwcEnabled ? '50' : '62'" />
                    @if(isPwcEnabled){
                        <h5 class="m-0 ml-2 product-name">Managed Review Deployment</h5>
                    }
            </div>
        }
        <div class="md:hidden block flex gap-2">
            @if(userRole === 'REVIEWER' && from === 'dashboard'){
            <div class="flex align-items-center">
                <!-- <i class="pi pi-bell text-2xl text-primary cursor-pointer" pBadge
                    value="{{getUnreadNotificationCount()}}"
                    (click)="getUnreadNotificationCount() > 0 && menu.toggle($event);toggleNotification(menu);"></i> -->
                    @if(!isResponsive){
                        <span (click)="getUnreadNotificationCount() > 0 && menu.toggle($event);toggleNotification(menu);"
                        pBadge value="{{getUnreadNotificationCount()}}"
                        class="{{helperService.getEnvironmentName()}}-icon icon-alert-outlined text-2xl text-primary cursor-pointer"></span>
                    }
                
            </div>
            <p-menu #menu [model]="notifications" [popup]="true" styleClass="w-full md:w-25rem overflow-auto h-30rem">
                <ng-template pTemplate="submenuheader" let-item>
                    <span class="font-medium text-sm ">Notifications</span>
                </ng-template>
                <ng-template pTemplate="item" let-item>
                    <div class="px-3 pt-3" (click)="markRead($event, item)">
                        <div class="flex flex-column gap-2 border-bottom-1 surface-border pb-3">
                            <div class="flex justify-content-between">

                                <div class="flex flex-column gap-2 w-8 as-end">
                                    <div class="flex flex-column text-black-alpha-80">
                                        <span [ngClass]="item.readMore ? 'white-space-nowrap' : ''"
                                            class="text-sm font-medium w-12 overflow-hidden text-overflow-ellipsis">{{
                                            item.subject }}</span>
                                        <span [ngClass]="item.readMore ? 'white-space-nowrap' : ''"
                                            class="text-sm w-12 overflow-hidden text-overflow-ellipsis">{{ item.message
                                            }}</span>
                                        <span class="text-xs font-medium text-primary as-end"
                                            (click)="readMore($event, item)">
                                            {{item.readMore ? 'Read More' : 'Read Less'}}</span>
                                    </div>
                                </div>

                                <div class="text-xs text-black-alpha-60 flex gap-1">
                                    <p-divider layout="vertical" styleClass="py-2" />
                                    <div class="flex flex-column">
                                        <span>{{item.createdAt | date:"MMMM dd YYYY" }}</span>
                                        <span class="font-bold">{{item.createdAt | date:"hh:mm a" }}</span>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </ng-template>
            </p-menu>
            }
        </div>

        @if((userRole === 'FIRM_MANAGER' || userRole === 'PROJECT_OWNER') && from === 'dashboard'){

            <app-multi-select (selectionChange)="searchMarketsSelected($event)" [selectedValues]="selectedSearchMarkets"
                optionLabel="name" optionValue="_id" [options]="searchMarkets" [helperService]="helperService">

            </app-multi-select>

        }

        @if(userRole === 'REVIEWER' && selectedTenant && selectedTenant.firm && from === 'dashboard' && (!isPwcEnabled || reviewerTenants.length > 1)){
        
            <p-dropdown inputId="float-label" [(ngModel)]="selectedTenant" (onChange)="onChangeTenant($event.value)"
            [options]="reviewerTenants" optionLabel="firm.name">
                <ng-template let-tenant pTemplate="selectedItem">
                    <div class="tenant-dropdown"><img alt="" class="firm-logo" [src]="tenant.logo" width="20" />{{
                        tenantNameForDropdown(tenant.firm.name) }}</div>
                </ng-template>
                <ng-template let-tenant pTemplate="item">
                    <div class="tenant-dropdown"><img alt="" class="firm-logo" [src]="tenant.logo" width="20" />{{
                        tenantNameForDropdown(tenant.firm.name) }}</div>
                </ng-template>
            </p-dropdown>

        }
    </div>
    <div class="p-ml-auto header-right">
        <div class="wrap-button align-items-center">
            <div class="md:block hidden">
                @if(userRole === 'REVIEWER' && from === 'dashboard'){
                <div class="flex align-items-center">
                    <span (click)="getUnreadNotificationCount() > 0 && menu.toggle($event);toggleNotification(menu);"
                    pBadge value="{{getUnreadNotificationCount()}}"
                    class="{{helperService.getEnvironmentName()}}-icon icon-alert-outlined text-xl primary cursor-pointer"></span>
                </div>
                <p-menu #menu [model]="notifications" [popup]="true"
                    styleClass="w-full md:w-25rem overflow-auto h-30rem">
                    <ng-template pTemplate="submenuheader" let-item>
                        <span class="font-medium text-sm ">Notifications</span>
                    </ng-template>
                    <ng-template pTemplate="item" let-item>
                        <div class="px-3 pt-3" (click)="markRead($event, item)">
                            <div class="flex flex-column gap-2 border-bottom-1 surface-border pb-3">
                                <div class="flex justify-content-between">

                                    <div class="flex flex-column gap-2 w-8 as-end">
                                        <div class="flex flex-column text-black-alpha-80">
                                            <span [ngClass]="item.readMore ? 'white-space-nowrap' : ''"
                                                class="text-sm font-medium w-12 overflow-hidden text-overflow-ellipsis">{{
                                                item.subject }}</span>
                                            <span [ngClass]="item.readMore ? 'white-space-nowrap' : ''"
                                                class="text-sm w-12 overflow-hidden text-overflow-ellipsis">{{
                                                item.message
                                                }}</span>
                                            <span class="text-xs font-medium text-primary as-end"
                                                (click)="readMore($event, item)">
                                                {{item.readMore ? 'Read More' : 'Read Less'}}</span>
                                        </div>
                                    </div>

                                    <div class="text-xs text-black-alpha-60 flex gap-1">
                                        <p-divider layout="vertical" styleClass="py-2" />
                                        <div class="flex flex-column">
                                            <span>{{item.createdAt | date:"MMMM dd YYYY" }}</span>
                                            <span class="font-bold">{{item.createdAt | date:"hh:mm a" }}</span>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </ng-template>
                </p-menu>
                }

            </div>
            @if(!isResponsive && isClientPortalUser()){
                <ng-container *ngTemplateOutlet="clientAccountMenu"></ng-container>
            }
            @if(!isResponsive && !isClientPortalUser()){
            <span (click)="logout()" class="{{helperService.getEnvironmentName()}}-icon icon-logout-outlined cursor-pointer primary text-xl"></span>
            }
        </div>
        @if(isClientPortalUser() && from === 'dashboard'){
        <!-- MP-5750: firm name from the portal session; no logo, documents/:id is not reachable by a CLIENT token. -->
        <div class="avatar lg:flex md:block hidden client-portal-firm">
            <div class="details">
                <h6 class="m-0">{{ clientFirmName() }}</h6>
                <p class="m-0">{{ clientGroupName() }}</p>
            </div>
        </div>
        }
        @if(!isPwcEnabled && userRole !== "REVIEWER" && userRole !== "ADMIN" && !isClientPortalUser() && from === 'dashboard'){
        <div class="avatar lg:flex md:block hidden">
            <p-avatar [image]="firmLogo" styleClass="header-avatar" size="large" shape="circle"></p-avatar>
            <div class="details">
                <h6 class="m-0">{{firmName$ | async}}</h6>
                <p [pTooltip]="(firmAddress$ | async) || 'No address available'" tooltipPosition="top"
                    *ngIf="firmAddress$ | async as address">
                    <span *ngFor="let chunk of breakAddress(address)">
                        {{ chunk }}
                    </span>
                </p>

            </div>
        </div>
        }
    </div>
    }
    @else{
        <div class="flex align-items-center justify-content-start">
            <p-image (click)="goToDashboard()" class="cursor-pointer" [src]="appLogo" alt="Image" [class.pt-2]="isPwcEnabled"
            [class.pwc-logo]="isPwcEnabled"
            [width]="isPwcEnabled ? '90' : '127'" 
            [height]="isPwcEnabled ? '50' : '62'" />
            @if(isPwcEnabled){
                <h5 class="m-0 ml-2 product-name pwc-product-name">Managed Review Deployment</h5>
            }
        </div>

    <div class="header-left">
        @if(!isResponsive && isMobile){
        <p-dropdown inputId="float-label" [(ngModel)]="selectedTenant" (onChange)="tenantSelected($event.value)"
            [options]="reviewerTenants" optionLabel="firm.name" />
        }
    </div>
    }
</div>

<!-- MP-5750: account menu for a client-portal user: name, client group, change password, logout. -->
<ng-template #clientAccountMenu>
    <div class="client-account-menu flex align-items-center gap-2">
        <div class="flex flex-column text-right">
            <span class="text-sm font-medium client-account-name">{{ clientUserName() }}</span>
            <span class="text-xs client-account-group">{{ clientGroupName() }}</span>
        </div>
        <p-button icon="pi pi-user" [rounded]="true" [text]="true" (onClick)="accountMenu.toggle($event)"
            ariaLabel="Account menu"></p-button>
        <p-menu #accountMenu [model]="accountMenuItems()" [popup]="true" appendTo="body"></p-menu>
    </div>
</ng-template>
